// The reducer that holds table data information.
// @flow
import { ACTIONS } from '../actions';
import type { RowState } from '../constants';

type Action = {
    rows: RowState,
    type: string
};

export const rows = (
    state: RowState = [],
    action: Action = { type: '', rows: [] }
): RowState => {
    switch (action.type) {
        case ACTIONS.INITIALIZE:
            if (action.rows) {
                return [...action.rows];
            }
            return state;
        default:
            return state;
    }
};
